// Feedback round 3 (EP-F8): someone signed in without an organisation of
// their own (an expert, or the funder's contract manager) who opens a team
// page gets this, with a link back to where they belong; never the set-up of
// a new organisation.
import { Link } from "react-router";
import { PageHeader } from "../ui/PageHeader";

/** `home` is Me.home: "/portal" for an expert, "/cm/<project>" for a contract manager. */
export function TeamOnlyPage({ home }: { home: string }) {
  const expert = home.startsWith("/portal");
  return (
    <>
      <PageHeader title="This page is for the project team" />
      <p>
        {expert
          ? "You are signed in with your expert account. This page belongs to the project team's part of Convenor, so it does not open for you."
          : "You are signed in as the funder's contract manager. This page belongs to the project team's part of Convenor, so it does not open for you."}
      </p>
      <p>
        <Link to={home}>{expert ? "Back to My work" : "Back to the shared project"}</Link>
      </p>
    </>
  );
}

/** Where a signed-in person without an organisation belongs, when it is not the organisation set-up. */
export function teamOnlyHome(home: string | undefined | null): string | null {
  return home && (home === "/portal" || home.startsWith("/portal/") || home.startsWith("/cm/")) ? home : null;
}
